import React, { useState } from "react";
// Import Header component
import Footer from "./Footer";
import "./css/HomeComponent.css";

const HomeComponent = () => {
  const [text, setText] = useState("");

  const handleSentenceCase = () => {
    const lines = text.split("\n");
    const transformedLines = lines.map((line) => {
      const trimmedLine = line.trim();
      if (trimmedLine.length === 0) return line; // Keep empty lines as they are
      // Capitalize the first letter of the line and convert the rest to lowercase
      return trimmedLine.charAt(0).toUpperCase() + trimmedLine.slice(1).toLowerCase();
    });
    setText(transformedLines.join("\n"));
  };
  
  const handleLowerCase = () => {
    setText(text.toLowerCase());
  };

  const handleUpperCase = () => {
    setText(text.toUpperCase());
  };

  const handleCapitalizedCase = () => {
    const lines = text.split("\n");
    const transformedLines = lines.map((line) => {
      return line
        .split(" ")
        .map((word) => {
          if (word.length === 0) return word; // Keep empty words as they are
          return word.charAt(0).toUpperCase() + word.slice(1);
        })
        .join(" ");
    });
    setText(transformedLines.join("\n"));
  };

  const handleAlternatingCase = () => {
    const transformedText = text
      .split("")
      .map((char, index) => {
        if (index % 2 === 0) return char.toLowerCase();
        return char.toUpperCase();
      })
      .join("");
    setText(transformedText);
  };

  const handleInverseCase = () => {
    const transformedText = text
      .split("")
      .map((char) => {
        if (char === char.toLowerCase()) {
          return char.toUpperCase();
        } else {
          return char.toLowerCase();
        }
      })
      .join("");
    setText(transformedText);
  };


  const handleDownloadText = () => {
    const blob = new Blob([text], { type: "text/plain;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "textfile.txt";
    link.click();
    URL.revokeObjectURL(url);
  };

  // Handle copying text to clipboard
  const handleCopyToClipboard = () => {
    navigator.clipboard.writeText(text).then(
      () => {
        alert("Text copied to clipboard!");
      },
      (err) => {
        alert("Failed to copy text: " + err);
      }
    );
  };

  // Handle clearing the textarea
  const handleClear = () => {
    setText("");
  };

  // Calculate text statistics
  const calculateTextStatistics = () => {
    const words = text
      .trim()
      .split(/\s+/)
      .filter((word) => word.length > 0);
    const letters = text.replace(/\s+/g, "");
    const sentences = text
      .split(/[.!?]+/)
      .filter((sentence) => sentence.trim().length > 0);
    const lines = text.split("\n");
    return {
      wordCount: words.length,
      letterCount: letters.length,
      sentenceCount: sentences.length,
      lineCount: lines.length,
    };
  };

  const { wordCount, letterCount, sentenceCount, lineCount } =
    calculateTextStatistics();

  return (
    <div className="home-container">
      <main>
        <h1>Rabbit Case</h1>
        <div className="content-box">
          <h2>
            Accidentally left the caps lock on and typed something, but can't be
            bothered to start again and retype it all?
          </h2>
          <p>
            Simply enter your text and choose the case you want to convert it
            to.
          </p>
          <div className="textarea-container">
            <textarea
              className="textarea-animated"
              placeholder="Start typing your notes here..."
              rows="10"
              value={text}
              onChange={(e) => setText(e.target.value)}
            />
          </div>
        
          <div className="stats-text">
            Words: {wordCount} | Letters: {letterCount} | Sentences:{" "}
            {sentenceCount} | Lines: {lineCount}
          </div>
          <br />
          
          <div className="btn-container">
            <button class="btn-422" onClick={handleSentenceCase}>
              Sentence case
            </button>
            <button class="btn-422" onClick={handleLowerCase}>
              lower case
            </button>
            <button class="btn-422" onClick={handleUpperCase}>
              UPPER CASE
            </button>
            <button class="btn-422" onClick={handleCapitalizedCase}>
              Capitalized Case
            </button>
            <button class="btn-422" onClick={handleAlternatingCase}>
              aLtErNaTiNg cAsE
            </button>
            <button class="btn-422" onClick={handleInverseCase}>
              InVeRsE CaSe
            </button>
            <button class="btn-422" onClick={handleDownloadText}>
              Download Text
            </button>
            <button class="btn-422" onClick={handleCopyToClipboard}>
              Copy to Clipboard
            </button>
            <button class="btn-422" onClick={handleClear}>
              Clear
            </button>
          </div>
        </div>
        <br />
        <div className="content1">
          <h3>Welcome to the Convert Case Text Generator Tool</h3>
          <p>
            A very handy online text tool where you can change between lower
            case and upper case letters, where you can capitalize, uncapitalize,
            convert to mix case and transform your text. Explore the options
            below:
          </p>
        </div>
        <br />
        <div className="content1">
          <h3>Sentence Case</h3>
          <p>
            The sentence case converter will allow you to paste any text you’d
            like, and it will automatically transform it to a fully formed
            structured sentence.
          </p>
          <p>
            It works by capitalizing the very first letter in each sentence, and
            will then go on to transform the rest of the text into lowercase as
            well as converting i’s into I’s. Every letter after a full stop will
            get converted into an upper case letter.
          </p>
          <p>Note: it won’t, however, capitalize names or places.</p>
          <p>This is an example of sentence case.</p>
        </div>
        <br />
        <div className="content1">
          <h3>Lower Case</h3>
          <p>
            If you are wondering how to uncapitalize text, this is exactly what
            the lower case text converter will allow you to do - it transforms
            all the letters in your text into lowercase letters. Simply copy the
            text that you need generating into lower case and paste the text
            into the box above and select the ‘lower case’ tab.
          </p>
          <p>this is an example of lower case.</p>
        </div>
        <br />
        <div className="content1">
          <h3>Upper Case</h3>
          <p>
            The upper case transformer will take any text that you have and will
            generate all the letters into upper case ones. It will essentially
            make all lower case letters into CAPITALS (as well as keep upper
            case letters as upper case letters).
          </p>
          <p>
            To do this, you simply have to select the text that you need
            changing and pasting into the box above and then select the UPPER
            CASE tab.
          </p>
          <p>THIS IS AN EXAMPLE OF UPPER CASE.</p>
        </div>
        <br />
        <div className="content1">
          <h3>Capitalized Case</h3>
          <p>
            The capitalized case converter will automatically convert the
            starting letter of every word into an upper case and will leave the
            remaining letters as lower case ones.
          </p>
          <p>
            Simply copy the content that you will like to generate into this
            format, then paste into the box form above and select the
            Capitalized Case tab.
          </p>
          <p>This Is An Example Of Capitalized Case.</p>{" "}
        </div>

        <br />
        <div className="content1">
          <h3>Alternating Case</h3>
          <p>
            The alternating case converter will allow you to transform your text
            (no matter the current format) into text that alternates between
            lower case and upper case. It will generate a capital letter and
            then a lower case letter within the same word.
          </p>
          <p>tHiS Is aN ExAmPlE Of aLtErNaTiNg cAsE.</p>
        </div>
        <br />
        <div className="content1">
          <h3>Title Case</h3>
          <p>
            The title case converter is perfect for those who are a bit unsure
            on how to title an upcoming essay. It essentially ensures the
            correct letters are capitalized within the context of a title. Words
            such as “an” will be left all in lower case and words that are
            important will be converted such as “Title”.
          </p>
          <p>This Is an Example of Title Case.</p>
        </div>
        <br />
        <div className="content1">
          <h3>Small Text Generator</h3>
          <p>
            The small text generator simply takes regular sized text and
            converts it into small text (specifically “small caps” as well as
            “Superscript” text. Write out your normal text and see it get
            converted into the small text font.
          </p>
          <p>Tʜɪꜱ ɪꜱ ᴀɴ ᴇxᴀᴍᴘʟᴇ ᴏꜰ ᴛɪɴʏ ᴛᴇxᴛ ᴄᴀꜱᴇ ꜱᴍᴀʟʟ ᴄᴀᴘꜱ</p>
          <p>ᵗʰⁱˢ ⁱˢ ᵃⁿ ᵉˣᵃᵐᵖˡᵉ ᵒᶠ ᵗⁱⁿʸ ᵗᵉˣᵗ ᶜᵃˢᵉ ˢᵘᵖᵉʳˢᶜʳⁱᵖᵗ</p>
        </div>
        <br />
        <div className="content1">
          <h3>Wide Text Generator</h3>
          <p>
            If you are looking to widen the look of your text, the widening text
            generator is great for this, otherwise known as the Aesthetic Font
            and text generator. Simply type your normal text and see it get
            wider and wider.
          </p>
          <p>
            Ｔｈｉｓ ｉｓ ａｎ ｅｘａｍｐｌｅ ｏｆ ｗｉｄｅ ａｅｓｔｈｅｔｉｃ ｔｅｘｔ。
          </p>
        </div>
        <br />
        <div className="content1">
          <h3>Strikethrough Text Generator</h3>
          <p>
            If you want a quick way of crossing out your text, this is a great
            tool. Type out the normal text you want to be lined through and you
            will see it get automatically generated, ready for you to copy and
            paste.
          </p>
          <p>T̶h̶i̶s̶ ̶i̶s̶ ̶a̶n̶ ̶e̶x̶a̶m̶p̶l̶e̶ ̶o̶f̶ ̶s̶t̶r̶i̶k̶e̶t̶h̶r̶o̶u̶g̶h̶ ̶t̶e̶x̶t̶.̶</p>
        </div>
        <br />
        <div className="content1">
          <h3>Reverse Text Generator</h3>
          <p>
            If you want a fast and quick way of making your text go back to
            front, the reverse text generator is great. Write out your text like
            normal and then see it get flipped.
          </p>
          <p>.txet sdrawkcab fo ecnetnes elpmaxe na si sihT</p>
        </div>
        <br />
        <div className="content1">
          <h3>Upside down Text Generator</h3>
          <p>
            Similar to the mirror text generator as wella s the reverse text
            generator, you can flip your text upside down as well as back to
            front with the upside down text generator.
          </p>
          <p>˙ʇxǝʇ uʍop ǝpᴉsdn ɟo ǝldɯɐxǝ uɐ sᴉ sᴉɥ┴</p>
        </div>
        <br />
        <div className="content1">
          <h3>Morse Code Translator</h3>
          <p>
            Whether you are looking to translate morse code messages into simple
            english or the other way around, this online translation generator
            can do just that. It also comes with an audio player to hear it.
          </p>
        </div>
        <br />
        <div className="content1">
          <h3>Binary Code Translator</h3>
          <p>
            Translate binary code into English and English into binary code with
            the following generator. Type out regularly and get a series of 0’s
            and 1’s in return.
          </p>
          <p>
            01000010 01101001 01101110 01100001 01110010 01111001 00100000
            01000011 01101111 01100100 01100101 00100000 01010100 01110010
            01100001 01101110 01110011 01101100 01100001 01110100 01101111
            01110010
          </p>
        </div>
        <br />
        <div className="content1">
          <h3>Bold Text Generator</h3>
          <p>
            A quick way to bold your text online. Simply type out the normal
            text into the tool and see it automatically get converted to the
            bold versio which you can copy and paste across.
          </p>
          <p>𝗧𝗵𝗶𝘀 𝗶𝘀 𝗮𝗻 𝗲𝘅𝗮𝗺𝗽𝗹𝗲 𝗼𝗳 𝗯𝗼𝗹𝗱 𝘁𝗲𝘅𝘁.</p>
        </div>
        <br />
        <div className="content1">
          <h3>Italic Text Converter</h3>
          <p>
            If you want to italicise your font, this is a great tool. Type out
            your normal text and see it automatically write on a slant, which
            you can copy and paste where you want.
          </p>
          <p>𝘛𝘩𝘪𝘴 𝘪𝘴 𝘢𝘯 𝘦𝘹𝘢𝘮𝘱𝘭𝘦 𝘰𝘧 𝘪𝘵𝘢𝘭𝘪𝘤 𝘵𝘦𝘹𝘵.</p>
        </div>
        <br />
        <div className="content1">
          <h3>Underline Text Generator</h3>
          <p>
            Underline your text online with this underliner tool. Write out or
            paste across the content you want to be underlined and then you will
            see it automatically generated underlined - which you can copy and
            paste across to where you want.
          </p>
          <p>T̲h̲i̲s̲ ̲i̲s̲ ̲a̲n̲ ̲e̲x̲a̲m̲p̲l̲e̲ ̲o̲f̲ ̲u̲n̲d̲e̲r̲l̲i̲n̲e̲ ̲t̲e̲x̲t̲.̲</p>
        </div>
        <br />
        <div className="content1">
          <h3>Mirror Text Generator</h3>
          <p>
            The mirror text is basically the exact same text that you would get
            when you have your text facing a mirror. Print out the text and hold
            it up to a mirror and it should read the correct way.
          </p>
          <p>.ƚxɘƚ ɿoɿɿim ʇo ɘlqmɒxɘ nɒ ƨi ƨiʜT</p>
        </div>
        <br />
        <div className="content1">
          <h3>Unicode Text Converter</h3>
          <p>
            Explore our unicode text generator for a wide range of different
            fonts. Type in your normal text and then choose whatever you want to
            use.
          </p>
        </div>
        <br />
        <div className="content1">
          <h3>Zalgo Glitch Text Generator</h3>
          <p>
            <p>
              Want to produce funky and glitchy text? `This Zalgo text will do
              just that. Type out what you would normally want to and then see
              it get turned into the Zalgo font.
            </p>
            T̵̡̧̨̖̪̗̠͔̰̓̈́̕͜ẖ̷̙̪̮̭̖̮̯̘͋͐̃̅͌̈́̆̕ͅȉ̶̛̫̟͎͋͗̓s̵̡͔̻͆̄͘ i̴̟͔͚͔͗͠ś̴̳̗͙ a̵̧̳͇̜̪̣̅̓n̸̛̰̼͇̱͐̎̀̽̌̐̿̈́̓ͅ ḛ̴̟̉͗x̷̬̩̀̕à̵̡̭̫̤̯͇̫͓̘͊̑͐̎̍͠m̶͎̦̾̾͠p̷̗̬̯̰͙̣̮̋̈́͆͊̇̿̋l̸̨̘̞̗̩̞̱͖̏̍̽̆͜͜e̸̱̹̬̞̹̍̇̓ͅ o̷̊ͅḟ̴͈̆̔̾̒́ g̴̤̪̻̰̗̀̓̎͋͝l̷̨͇͔͈̤̝̊̀̂͛͜į̴̡̦̼̄̏̏͛̒ẗ̶̙̻̜̺͉́̽̒̅̀̐͝c̸̛̛͇̱͇̮͔͔͙̼̀̈́̀͜h̵̙̘̣̻͈̫͇̜͂́̍͊͗̀͜ t̷̬̹̜̼̫̘͒̊ę̷̰̬̠̭̠͉̳̐́̒͑͋̓̎̽̈́͠x̷̢̢̛͓̜͚̖̜͕̼̙̌̍ţ̵̖͖̜̜̪́̎͒̚͜͝.̷̛̬̖̳̻̪̩̾̾̆̄̓͋͒̚͠
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default HomeComponent;
